import flow from 'lodash/fp/flow';
import { configuratorReducer } from '@gcc/configurator';
import extension from './extension';

const standardConfigReducer = (action) => (state) => configuratorReducer(state, action);
export default (state, action) => flow(
  standardConfigReducer(action),
  extension(action),
)(state);
